import * as PIXI from 'pixi.js';
import { TweenMax } from 'gsap';
import Cloud from './Cloud';

const images = [];
const appWidth = 1280;
const appHeight = 720;
let app;
let container;

const model = [{x0:1078.95, y:342.35, scale:0.363555908203125, x1:2585.35}, {x0:402.85, y:353.8, scale:0.40582275390625, x1:-533.4}, {x0:997.05, y:418.7, scale:0.4031298088763682, x1:2017.3}, {x0:187.6, y:392.1, scale:0.440216064453125, x1:-1222.8}, {x0:321.95, y:432.9, scale:0.4031390470914698, x1:-576.25}, {x0:1075.5, y:473, scale:0.549285888671875, x1:2051.7}, {x0:614.5, y:375.15, scale:0.40313720703125, x1:506.45}, {x0:756.4, y:348.7, scale:0.35491943359375, x1:1199.65}, {x0:815.1, y:383.95, scale:0.4031390470914698, x1:1365.25}, {x0:579.65, y:430.1, scale:0.40582275390625, x1:381.6}, {x0:832, y:457.65, scale:0.395660400390625, x1:1282.15}, {x0:807.5, y:491.25, scale:0.4031298088763682, x1:1157.6}, {x0:505.75, y:458.35, scale:0.4031390470914698, x1:143.65},
  {x0:1078.95, y:342.35, scale:0.363555908203125, x1:2585.35}, {x0:402.85, y:353.8, scale:0.40582275390625, x1:-533.4}, {x0:997.05, y:418.7, scale:0.4031298088763682, x1:2017.3}, {x0:187.6, y:392.1, scale:0.440216064453125, x1:-1222.8}, {x0:321.95, y:432.9, scale:0.4031390470914698, x1:-576.25}, {x0:1075.5, y:473, scale:0.549285888671875, x1:2051.7}, {x0:614.5, y:375.15, scale:0.40313720703125, x1:506.45}, {x0:756.4, y:348.7, scale:0.35491943359375, x1:1199.65}, {x0:815.1, y:383.95, scale:0.4031390470914698, x1:1365.25}, {x0:579.65, y:430.1, scale:0.40582275390625, x1:381.6}, {x0:832, y:457.65, scale:0.395660400390625, x1:1282.15}, {x0:807.5, y:491.25, scale:0.4031298088763682, x1:1157.6}, {x0:505.75, y:458.35, scale:0.4031390470914698, x1:143.65},
  {x0:1078.95, y:342.35, scale:0.363555908203125, x1:2585.35}, {x0:402.85, y:353.8, scale:0.40582275390625, x1:-533.4}, {x0:997.05, y:418.7, scale:0.4031298088763682, x1:2017.3}, {x0:187.6, y:392.1, scale:0.440216064453125, x1:-1222.8}, {x0:321.95, y:432.9, scale:0.4031390470914698, x1:-576.25}, {x0:1075.5, y:473, scale:0.549285888671875, x1:2051.7}, {x0:614.5, y:375.15, scale:0.40313720703125, x1:506.45}, {x0:756.4, y:348.7, scale:0.35491943359375, x1:1199.65}, {x0:815.1, y:383.95, scale:0.4031390470914698, x1:1365.25}, {x0:579.65, y:430.1, scale:0.40582275390625, x1:381.6}, {x0:832, y:457.65, scale:0.395660400390625, x1:1282.15}, {x0:807.5, y:491.25, scale:0.4031298088763682, x1:1157.6}, {x0:505.75, y:458.35, scale:0.4031390470914698, x1:143.65}];

function setup() {
  container = new PIXI.Container();

  app.stage.addChild(container);

  const graphics = new PIXI.Graphics();
  graphics.beginFill(0x131542);
  graphics.drawRect(0, 0, appWidth, appHeight);
  graphics.alpha = 0.3;
  graphics.endFill();
  graphics.blendMode = PIXI.BLEND_MODES.DARKEN;

  app.stage.addChild(graphics);

  const cloudMax = 45;
  for (let i = 0; i < cloudMax; i++) {
    let cloud = new Cloud(images[i % 2], { aplication: app, model: model[i % model.length], container: container, cloudMax: cloudMax, id : i });
  }

  TweenMax.set(container, { pixi: { rotation: -3 } });

  TweenMax.from(container, 7, { alpha: 0, ease: Linear.easeIn });
  TweenMax.to(container, 20, { y: '+=20', yoyo:true, repeat: -1, ease: Sine.easeInOut });
  TweenMax.to(container, 15, { pixi: { rotation: 3 }, yoyo: true, repeat: -1, ease: Sine.easeInOut });

  // Listen for animate update
  // app.ticker.add(function(delta) {
  //
  // });
}

export default function initBg() {
  app = new PIXI.Application({
    width: appWidth, height: appHeight, backgroundColor: 0x131542, resolution: 1,
  });
  document.querySelector('#background').appendChild(app.view);
  PIXI.SCALE_MODES.DEFAULT = PIXI.SCALE_MODES.NEAREST;

  const loader = new PIXI.Loader();
  loader
    .add('skyCloud1', 'static/img/skyCloud1.png')
    .add('skyCloud2', 'static/img/skyCloud2.png')
    .load((loader, resources) => {
      images.push(resources.skyCloud1.texture);
      images.push(resources.skyCloud2.texture);
    });

  loader.onComplete.add(setup);
}



// WEBPACK FOOTER //
// ./src/js/backgroundClouds/backgroundClouds.js